import React from 'react';
import PartnerBookTalkHead from '../components/PartnerBookTalkHead';
import useAvailableAssociates from '../../hooks/useAvailableAssociates';
import { motion } from 'framer-motion';

interface PartnerBookTalkProps {
  content;
  currentUser;
  talkNow: Function;
  bookNow: Function;
  chatNow: Function;
  onTalkNow: Function;
  onScheduleNow: Function;
  viewUser: Function;
  getImageSrc: Function;
}
const PartnerBookTalk: React.FC<PartnerBookTalkProps> = ({
  content,
  currentUser,
  talkNow,
  bookNow,
  chatNow,
  onTalkNow,
  onScheduleNow,
  viewUser,
  getImageSrc,
}) => {
  const mShowTalkBtn = false;

  const availableAssociates = useAvailableAssociates(content);

  if (content.Associates.length == 0) {
    return <></>;
  }

  //@ts-ignore
  if (CrowdHub_App.CONFIG.PARTNER_BOOK_TALK_COMPANYWIDE) {
    function TalkNowButton() {
      return (
        <div
          id="talknow_button"
          className="mini_button_outline margin_top_big margin_bottom_big"
          onClick={() => {
            onTalkNow();
          }}
        >
          {
            //@ts-ignore
            CrowdHub_App.LANG.BUTTON_TALKNOW
          }
        </div>
      );
    }

    return (
      <div
        className={'partner_book_talk ui_relative element desktop_max_width'}
        role={'region'}
        aria-label={
          //@ts-ignore
          `${CrowdHub_App.LANG.UP_TALK_WITH_OUR_TEAM}: ${CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT}`
        }
      >
        <div className={'partner_book_title ui_textalign_center'}>
          <div className={'title'}>
            {
              //@ts-ignore
              CrowdHub_App.LANG.UP_TALK_WITH_OUR_TEAM
            }
          </div>
          <div className={'desc'}>
            {
              //@ts-ignore
              CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT
            }
          </div>

          <div className="booknow_companywide" style={/*{display:"flex"}{marginBottom: "50px"}*/ {}}>
            {mShowTalkBtn && <TalkNowButton></TalkNowButton>}
            <motion.div whileHover={{ scale: 1.1 }}>
              <div
                id="schedulenow_button"
                className="mini_button_outline margin_top margin_bottom"
                onClick={() => {
                  onScheduleNow();
                }}
              >
                {
                  //@ts-ignore
                  CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT
                }
              </div>
            </motion.div>
          </div>
        </div>

        {content.Associates.length == 0
          ? null
          : content.Associates.map(function (speaker, i) {
              return (
                <PartnerBookTalkHead
                  associate={speaker}
                  content={content}
                  currentUser={currentUser}
                  talkNow={talkNow}
                  bookNow={bookNow}
                  chatNow={chatNow}
                  availableAssociates={availableAssociates}
                  viewUser={viewUser}
                  getImageSrc={getImageSrc}
                ></PartnerBookTalkHead>
              );
            })}
      </div>
    );
  } else {
    return (
      <div
        className={'partner_book_talk ui_relative element desktop_max_width'}
        role={'region'}
        aria-label={
          //@ts-ignore
          `${CrowdHub_App.LANG.UP_TALK_WITH_OUR_TEAM}: ${CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT}`
        }
      >
        <div className={'partner_book_title ui_textalign_center'}>
          <div className={'title'}>
            {
              //@ts-ignore
              CrowdHub_App.LANG.UP_TALK_WITH_OUR_TEAM
            }
          </div>
          <div className={'desc'}>
            {
              //@ts-ignore
              CrowdHub_App.LANG.SCHEDULE_A_TIME_TO_CHAT
            }
          </div>
        </div>

        {content.Associates.length == 0
          ? null
          : content.Associates.map(function (speaker, i) {
              return (
                <PartnerBookTalkHead
                  key={speaker.Id}
                  associate={speaker}
                  content={content}
                  currentUser={currentUser}
                  talkNow={talkNow}
                  bookNow={bookNow}
                  chatNow={chatNow}
                  availableAssociates={availableAssociates}
                  viewUser={viewUser}
                  getImageSrc={getImageSrc}
                ></PartnerBookTalkHead>
              );
            })}
      </div>
    );
  }
};
export default PartnerBookTalk;
